import { render, staticRenderFns } from "./GradeReport.vue?vue&type=template&id=cb80b876&scoped=true"
import script from "./GradeReport.vue?vue&type=script&lang=js"
export * from "./GradeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb80b876",
  null
  
)

export default component.exports